@if (!!addSelectAllButton) {
  <mat-checkbox
    [class]="checkboxClass + ' text-base'"
    color="primary"
    [checked]="!!allSelected"
    class="hover:bg-white font-bold"
    (click)="selectAllToggleClick()"
    [indeterminate]="!!someSelected"
    [disabled]="formControl.disabled"
    >
    @if (!!selectAllIcon) {
      <ng-icon
        [name]="selectAllIcon"
        [class]="iconClass"
      ></ng-icon>
    }
    {{showAllText}}</mat-checkbox
    >
  }

  @for (opt of options | async; track opt) {
    <mat-checkbox
      [disabled]="opt.disabled"
      color="primary"
      [class]="checkboxClass + ' text-base'"
      [checked]="!!formControl.value.includes(opt.value)"
      (change)="onCheckBoxChange($event, opt.value)"
      [value]="opt.value"
      class="hover:bg-white font-bold"
      [disabled]="formControl.disabled"
      >
      @if (!!opt.icon) {
        <ng-icon [name]="opt.icon" [class]="iconClass"></ng-icon>
      }
      {{ opt.label }}</mat-checkbox
      >
    }
